// extracted by mini-css-extract-plugin
module.exports = {"listScroll":"LozengeList_listScroll__5Pd2T","list":"LozengeList_list__ph3W1","stackList":"LozengeList_stackList__KrnaV","smallGap":"LozengeList_smallGap__B4nwA"};